import { render, staticRenderFns } from "./PrefixCreate.vue?vue&type=template&id=614653ad&"
import script from "./PrefixCreate.vue?vue&type=script&lang=js&"
export * from "./PrefixCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports